<template>
    <!-- 研修活动 -->
    <div>
        <CommonTitle :title="modelTitle" @goMore="goMore" :showMore="true" :tag-list="tagList" @changeTag="onChangeTag"/>
        <ul class="activity-list" v-if="total">
            <li class="activity-list-item" v-for="item in activityList" :key="item.id" @click="goDetail(item.id)">
                <div v-link="jumpHref.activity.detail(item.id)" class="activity-list-item-link">
                    <div class="list-item-img">
                        <!-- <img class="img" referrerpolicy="no-referrer" :src="item.activityCover" alt=""> -->
                        <LazyImage :src="item.activityCover" className="img"/>
                        <ActivityLabel class="list-item-label" :class=[activityStatus[item.state].class] :label="activityStatus[item.state].label"/>
                    </div>
                    <div class="list-item-content" >
                        <div class="activity-title ellipsis-2" :title="item.title" v-link="jumpHref.activity.detail(item.id)">
                            {{item.title}}
                        </div>
                        <div class="activity-time-box">
                            <span class="activity-time-label">开始时间</span>
                            <span class="activity-time">{{item.startTime && dayjs(item.startTime).format('YYYY.MM.DD') || ''}}</span>
                        </div>
                    </div>
                </div>
            </li>
            
        </ul>
        <BigNoData
            v-if="!total"
            class="no-data"
            url="no-activity@2x.png"
            :info="`暂无${modelTitle || '研修活动'}`"
            />
    </div>
</template>
<script setup>
    import { ref, reactive, onMounted } from 'vue'
    import { useStore } from 'vuex'
    import dayjs from 'dayjs';
    import CommonTitle from '@/components/home-common-title/index.vue'
    import ActivityLabel from './activity-label.vue'
    import BigNoData from '@/components/no-data.vue'
    import { pageJump } from '@/global/location-transfer'
    import { jumpHref } from '@/router/jumpHref.js';
    import LazyImage from '@/components/lazy-image/lazy-image.vue';

    const props = defineProps({
        modelTitle: {
            type: String,
            default: ''
        },
        tagList: {
            type: Array,
            default: () => {
                return []
            }
        },
        doubleNew: {
            type: Boolean,
            default: false
        }
    })

    const store = useStore()
    const activityStatus = reactive({
        1: {
            label: '关闭禁用',
            class: 'ended'
        },
        11: {
            label: '未开始',
            class: 'unbegin'
        },
        12: {
            label: '进行中',
            class: ''
        },
        20: {
            label: '已结束',
            class: 'ended'
        }
    })
    const activityList = ref([])
    const filterData = reactive({
        pageIndex: 1,
        pageSize: 4,
        orderBy: 'hot',
        queryScope: 'dtBrand',
        stageSubjectIds: ''
    });


    const total = ref(0);
    function getList() {
        G_transmit('activityPublishPage', {
            name: 'activityPublishPage',
            params: {
                ...filterData
            },
            message: false
        }).then((res) => {
            if(res.data && res.data.rows){
                activityList.value = res.data.rows || [];
                total.value = res.data.total;
            }
        })
    }
    const goMore = () => {
        pageJump({name: 'activitySquare'});
    }

    function goDetail(id) {
        pageJump(jumpHref.activity.detail(id), true);
    }

    const onChangeTag = (tag) => {
        filterData.stageSubjectIds = tag.join(',')
        getList()
    }

    onMounted(() => {
        let tag = props.doubleNew ? [1204] : []
        onChangeTag(tag)
    })
</script>

<style lang="scss" scoped>
.activity-list {
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
}
.activity-list-item {
    box-sizing: border-box;
    width: 585px;
    height: 185px;
    display: flex;
    background: var(--home-color-bg-ligter);
    border-radius: 4px;
    padding: 25px 20px 20px 20px;
    margin-top: 30px;
    margin-left: 30px;
    cursor: pointer;
    &:hover {
        box-shadow: 0px 1px 12px 0px rgba(0,0,0,0.1500);
        .activity-title {
            color: var(--home-main-color) !important;
        }
    }
    .list-item-img {
        width: 250px;
        height: 140px;
        position: relative;
        .img {
            width: 100%;
            height: 100%;
            border-radius: 4px;
        }
        .list-item-label {
            position: absolute;
            left: 12px;
            top: -5px;
        }
    }
    .list-item-content {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        margin-left: 16px;
        .activity-title {
            font-size: 18px;
            font-weight: bold;
            color: var(--color-black);
            line-height: 27px;
            margin-top: 9px;
        }
        .activity-time-box {
            margin-bottom: 16px;
            .activity-time-label {
                display: inline-block;
                width: 85px;
                height: 26px;
                box-sizing: border-box;
                background-image: url('~@/assets/img/time-label.png');
                background-size: 100% 100%;
                background-repeat: no-repeat;
                border-radius: 4px 4px 0px 4px;
                padding-left: 10px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3D2003;
                line-height: 26px;
                margin-right: -17px;
                position: relative;
            }
            .activity-time {
                width: 118px;
                height: 22px;
                display: inline-block;
                box-sizing: border-box;
                padding-left: 22px;
                background: linear-gradient(360deg, var(--nav-top-bg-color) 0%, var(--nav-bottom-bg-color) 100%);
                border-radius: 0px 18px 18px 0px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 22px;
                vertical-align: bottom;
            }
        }
    }
}
.activity-list-item-link{
    display: flex;
}
.activity-list-item:nth-child(1), .activity-list-item:nth-child(2) {
    margin-top: 26px;
}
.activity-list-item:nth-child(2n+1) {
    margin-left: 0;
}
.ellipsis-2 {
    word-break: break-all;
    text-overflow: ellipsis;
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.no-data {
    margin-top: 50px;
}
</style>